import { z } from 'zod';

const englishIqDemoClipV2Schema = z.object({
  durationMs: z.number().int().min(3000).max(5000),
  id: z.number().int().positive(),
  url: z.string().url(),
});

export const englishIqDemoV2Schema = z.object({
  challenge: z.string().min(1),
  clips: z.tuple([englishIqDemoClipV2Schema, englishIqDemoClipV2Schema]),
  meaning: z.string().min(1),
});

export type IEnglishIqDemoV2 = z.infer<typeof englishIqDemoV2Schema>;
